import ERC20 from '../abi/ERC20.json';
import { ethers } from 'ethers';
import { getAddress } from './get-address';

export const getDumpsterSubmissionAllowance = async (_token, _address, _decimals) => {
    let allowance = 0;
    try {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const { chainId } = await provider.getNetwork();
        const addresses = getAddress(chainId);

        if (addresses) {
            const signer = provider.getSigner();
            const tokenContract = new ethers.Contract(_token, ERC20.abi, signer);

            const response = await tokenContract.allowance(
                _address,
                addresses.dumpster_submission
            );
            allowance = parseFloat(response.toString()) / 10 ** _decimals;

            return {
                success: true,
                allowance: allowance
            };
        } else {
            return { success: false, message: 'Wrong Network!' };
        }
    } catch (e) { 

        // For other errors, return a simplified message
        return { success: false, message: `Error: ${e.message.split("(")[0]}` }; // Keep only the main error message

    }
};
